import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
border-bottom:1px solid rgba(103, 103, 103, .45);
display:flex;
flex-direction:column;
text-align:center;
justify-content:flex-start;
padding-bottom:10px;
margin-bottom:10px;
> *{
    width:100%;
    margin-bottom:10px;
 }
 @media screen and (min-width: 750px) {
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    text-align:right;
     > *{
        width:auto;
        margin-bottom:0;
     }
    }
    
    `
const NewCommentLabel = styled.label`
color: #6a289b;
`
const NewCommentButton = styled.button`
padding: 8px 20px 5px;
background-color: #6a289b;
color: #fff;
cursor: pointer;
`

const CommentCountLabel = styled.label`
order: -1;
@media screen and (min-width: 750px) {
    
    order:0;
    
}
`
const NewCommentTag = (props) => {
    return props.show ? (<NewCommentLabel>כתוב תגובה חדשה</NewCommentLabel>) :
        (<NewCommentButton onClick={props.btnOnClick}>הוסף תגובה חדשה</NewCommentButton>)
}
const CommentsTopBar = (props) => {
    return (
        <Container>
            <NewCommentTag show={props.showAddBtn} btnOnClick={props.onAddBtnClick} />
            <CommentCountLabel>
                לכתבה זו התפרסמו <span>{props.commentCount} תגובות</span>
            </CommentCountLabel>
        </Container>
    )
}

export default CommentsTopBar;


// WEBPACK FOOTER //
// ./src/Components/comments/CommentsTopBar.jsx